import { Github, Linkedin, Mail } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
      <div className="container py-8">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {currentYear} Ravindra Singh Rathor. All rights reserved.
          </p>
          
          <div className="flex items-center gap-4">
            <a
              href="https://github.com/softwareprovider-ravindra"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 transition-all hover:text-primary-600 hover:scale-110 dark:text-gray-400 dark:hover:text-primary-400"
              aria-label="GitHub"
            >
              <Github size={20} />
            </a>
            <a
              href="https://linkedin.com/in/softwareprovider-ravindra"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 transition-all hover:text-primary-600 hover:scale-110 dark:text-gray-400 dark:hover:text-primary-400"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
            <a
              href="mailto:softwareprovider.ravindra@gmail.com"
              className="text-gray-600 transition-all hover:text-primary-600 hover:scale-110 dark:text-gray-400 dark:hover:text-primary-400"
              aria-label="Email"
            >
              <Mail size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
